import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// GA4 page_view: exactly one per pathname (initial load + each SPA navigation).
// gtag is loaded once in index.html with send_page_view:false, so nothing double-counts.
// We wait for the route's document.title to settle (article titles arrive after fetch).
export default function GaTracker() {
    const { pathname } = useLocation();
    const sentPathRef = useRef("");
    const lastTitleRef = useRef(document.title);

    useEffect(() => {
        if (sentPathRef.current === pathname || typeof window.gtag !== "function") return;

        const prevTitle = lastTitleRef.current;
        let done = false;
        let observer, timer;
        const send = () => {
            if (done || sentPathRef.current === pathname) return;
            done = true;
            sentPathRef.current = pathname;
            lastTitleRef.current = document.title;
            if (observer) observer.disconnect();
            clearTimeout(timer);
            window.gtag("event", "page_view", {
                page_title: document.title,
                page_location: window.location.href,
                page_path: pathname,
            });
        };

        if (document.title !== prevTitle) { send(); return; }
        const titleEl = document.querySelector("title");
        observer = new MutationObserver(() => { if (document.title !== prevTitle) send(); });
        if (titleEl) observer.observe(titleEl, { childList: true, characterData: true, subtree: true });
        timer = setTimeout(send, 2500);
        return () => { observer.disconnect(); clearTimeout(timer); };
    }, [pathname]);

    return null;
}
